import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class MapService {
  private usersettingsUrl = environment.serverUrl+'MapSettings';  // URL to web api  // URL to web api
  constructor(private http: HttpClient) { }

  
  public get = (route: string) => {
    return this.http.get(this.createCompleteRoute(route, this.usersettingsUrl));
  }
  private createCompleteRoute = (route: string, envAddress: string) => {
    return `${envAddress}/${route}`;
  }

  private generateHeaders = () => {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
  }
}
